<p>loanlogics-pricing-service-fee-setup works!</p>
